module.exports = __webpack_public_path__ + "img/process.b53097f8.webp";